import { observable, action } from "mobx";
import { createContext, useContext } from "react";

export class ErrorModalStore {
  @observable
  show = false;

  @observable
  retryCta: any;

  @action
  showAlert() {
    this.show = true;
  }

  @action
  hideAlert() {
    this.show = false;
  }

  onClick() {
    this.hideAlert();
    this.retryCta?.();
  }
}

export const ErrorModalStoreContext = createContext(new ErrorModalStore());

export const useErrorModalStore = () => useContext(ErrorModalStoreContext);
